<div>
	<div class="uk-container">
		<h1>Регионы</h1>
	</div>
	<div class="uk-container">
		<div *ngIf="cities.length > 0" class="uk-child-width-1-2 uk-child-width-1-4@m uk-grid" uk-grid>
			<span class="uk-display-block uk-link"
				  *ngFor="let city of cities">
				<a (click)="changeCurrentCity(city.CODE)" [routerLink]="[city.CODE]">{{ city.NAME }}</a>
			</span>
		</div>

	</div>
</div>
